import type {SupportedCurrency} from 'src/v2/state/types';
import {MAX_UINT_256_VALUE} from 'src/utils/constants';
import type {TypedDataDomain, TypedDataParameter} from 'viem';

export const getPermitMessage = ({
  spender,
  ownerWallet,
  asset,
  tokenName,
  nonce,
  tokenVersion,
  validBefore,
  permitValue,
}: {
  spender: string;
  ownerWallet: string;
  asset: SupportedCurrency;
  tokenName: string;
  nonce: bigint;
  tokenVersion: string;
  validBefore: string;
  permitValue?: bigint;
}): {
  domain: TypedDataDomain;
  types: Record<string, TypedDataParameter[]>;
  message: {
    owner: string;
    spender: string;
    value: bigint;
    deadline: bigint;
  };
  primaryType: string;
} => {
  const types = {
    Permit: [
      {name: 'owner', type: 'address'},
      {name: 'spender', type: 'address'},
      {name: 'value', type: 'uint256'},
      {name: 'nonce', type: 'uint256'},
      {name: 'deadline', type: 'uint256'},
    ],
  };

  const domain = {
    name: tokenName,
    version: tokenVersion,
    chainId: asset.chainId,
    verifyingContract: asset.contractAddress as `0x${string}`,
  };

  // CRYPTO_PAYINS-640: Use deadline provided by the server rather than Date.now() so we don't have to rely on the user's system clock
  const sigDeadline = BigInt(validBefore);

  const message = {
    owner: ownerWallet,
    spender,
    value: permitValue ?? MAX_UINT_256_VALUE,
    nonce: nonce.toString(),
    // How long we have to submit this signature on chain
    deadline: sigDeadline,
  };

  const primaryType = 'Permit';

  return {domain, types, message, primaryType};
};
